<div>
    <app-equilibrar
        [(cr)]="this.cr"
        [(currentList)]="this.currentList"
        [(billDueDateField)]="this.billDueDateField"
        [(billDateField)]="this.billDateField"
        [(lastPaymentAmountField)]="this.lastPaymentAmountField"
        [(billBalanceField)]="this.billBalanceField"
        (updateinitializeData)="this.initializeData()">
    </app-equilibrar>
</div>
<div>
    <app-payment-options
        [(cr)]="this.cr"
        [(accountType)]="this.accountType"
        [(accountSubtype)]="this.accountSubtype"
        [(type)]="this.type" 
        [(token)]="this.token" 
        [(selectBan)]="this.selectBan" 
        [(billBalanceField)]="this.billBalanceField"
        [(paperless)]="this.paperless"
        (updateBillBalanceField)="this.billBalanceField=$event">
    </app-payment-options>    
</div>